'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// message bus events used for tracking

var MESSAGE_TRACKING_QD_OPEN = exports.MESSAGE_TRACKING_QD_OPEN = 'quick_deposit_open';
var MESSAGE_TRACKING_QD_START = exports.MESSAGE_TRACKING_QD_START = 'quick_deposit_start';
var MESSAGE_TRACKING_QD_SUCCESSFUL = exports.MESSAGE_TRACKING_QD_SUCCESSFUL = 'quick_deposit_successful';
var MESSAGE_TRACKING_QD_UNSUCCESSFUL = exports.MESSAGE_TRACKING_QD_UNSUCCESSFUL = 'quick_deposit_unsuccessful';

var GENERIC_ERROR_FIELD_IDENTIFIER = exports.GENERIC_ERROR_FIELD_IDENTIFIER = 'Quick Deposit Error';